import { useSearchParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import GitHubIcon from '@mui/icons-material/GitHub'
import AppleIcon from '@mui/icons-material/Apple'
import EmailIcon from '@mui/icons-material/AlternateEmail'
import PasswordIcon from '@mui/icons-material/Password'

import Link from '~/client/components/Link'

const PROVIDERS = {
  github: {
    icon: <GitHubIcon/>,
    href: '/api/login/github',
    title: 'Github',
  },
  apple: {
    icon: <AppleIcon/>,
    href: '/api/login/apple',
    title: 'Apple',
  },
  email: {
    icon: <EmailIcon/>,
    href: '/login/email',
    title: 'Email',
  },
  password: {
    icon: <PasswordIcon/>,
    href: '/login/local',
    title: 'Email & Password',
  },
}


export default function AuthButton({
  children,
  provider,
  icon = PROVIDERS[provider]?.icon,
  title = PROVIDERS[provider]?.title,
  to = PROVIDERS[provider]?.href,
  destination,
  ...props
}){
  const [searchParams] = useSearchParams()
  if (destination) searchParams.set('destination', destination)
  return <Button
    variant="contained"
    component={Link}
    to={`${to}?${searchParams}`}
    title={title}
    {...props}
  >
    {icon}&nbsp;
    <Box sx={{flexGrow: 1, textAlign: 'center'}}>
      {children || title}
    </Box>
  </Button>
}
